import Vue from 'vue'
import store from './store'
import router from './router'
import App from './components/App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/cyma-c.less'
import { installI18n } from './i18n'

Vue.use(ElementUI)
installI18n(Vue, store)

document.documentElement.classList.add('cyma-c-site')
document.body.classList.add('cyma-c-site')
document.documentElement.lang = store.state.locale === 'en-US' ? 'en' : 'zh-CN'

new Vue({
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount('#app')
